var _style, _path, _rect, _rect2, _path2, _path3, _path4, _rect3, _path5, _rect4, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTruckTanker(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 459.7 135.3",
    style: {
      enableBackground: "new 0 0 459.7 135.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#D5D6DB;}\r\n\t.st1{fill:#3A556A;}\r\n\t.st2{fill:#64798A;}\r\n\t.st3{fill:#E56353;}\r\n\t.st4{fill:#F7BE56;}\r\n\t.st5{fill:#EBF0F3;}\r\n\t.st6{fill:#27A2DB;}\r\n\t.st7{fill:#2F4859;}\r\n\t.st8{fill:#E1E6E9;}\r\n\t.st9{fill:none;stroke:#64798A;stroke-width:5;stroke-miterlimit:10;}\r\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "tanker") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16.5,74.3v21.8H8.3V84.3C8.3,79.4,11.7,75.3,16.5,74.3z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 195.4,
    y: 86.7,
    className: "st1",
    width: 38.4,
    height: 12.2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 347.7,
    y: 86.7,
    className: "st1",
    width: 97,
    height: 12.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M131.7,9.6v21.9h-5.1V9.6c-0.1-1.4,1-2.6,2.4-2.7c1.4-0.1,2.6,1,2.7,2.4C131.7,9.3,131.7,9.4,131.7,9.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M135,30.1v73.1h-11.8V30.1c0-1.3,1-2.3,2.3-2.3h7.1C134,27.8,135,28.8,135,30.1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M457.8,101.2h-4.4v10.6h4.4c1,0,1.9-0.8,1.9-1.9l0,0v-6.8C459.7,102,458.9,101.2,457.8,101.2L457.8,101.2z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 341,
    y: 94.1,
    className: "st2",
    width: 113.8,
    height: 22.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M274.1,103.1v6.8c0,1-0.8,1.9-1.9,1.9l0,0h-4.4v-10.6h4.4C273.3,101.2,274.1,102,274.1,103.1z"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 112.6,
    y: 94.1,
    className: "st2",
    width: 156.9,
    height: 21.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M119.6,68.5v48.9H13.4V73.8L55,68.5V44.9h-2.9c-1,0-1.8-0.8-1.8-1.8v-2c0-1,0.8-1.8,1.8-1.8h67.4L119.6,68.5 L119.6,68.5z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M18.2,93.5v24H4.3c-2.4,0-4.3-1.9-4.3-4.3c0,0,0,0,0-0.1V97.8c0-2.4,1.9-4.3,4.3-4.3l0,0H18.2z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M7.8,105.6c0,2.5-2,4.6-4.5,4.7v-9.5C5.8,100.9,7.8,103,7.8,105.6z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M102.4,50v60.3H82.2c0-10.4-8.2-18.9-18.6-19.4l1.8-41.1c0.1-1.8,1.5-3.2,3.3-3.2H99 C100.9,46.7,102.4,48.2,102.4,50L102.4,50z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M95.6,51.4c-0.1-0.9-0.9-1.6-1.8-1.6H72.4c-0.9,0-1.7,0.7-1.8,1.6l-1.7,12.7c-0.1,1,0.6,1.9,1.6,2.1 c0.1,0,0.2,0,0.3,0h24.8c1,0,1.8-0.8,1.8-1.8c0-0.1,0-0.2,0-0.3L95.6,51.4z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M58,49.1h-4.1c-0.7,0-1.3,0.5-1.3,1.2l-1.2,15.1c-0.1,0.7,0.5,1.4,1.2,1.4h0.1H58c0.7,0,1.3-0.6,1.3-1.3V50.4 C59.3,49.7,58.7,49.1,58,49.1L58,49.1z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M114.1,48.7h-7c-1.3,0-2.3,1-2.3,2.3v14c0,1.3,1,2.3,2.3,2.3l0,0h7c1.3,0,2.3-1,2.3-2.3l0,0V51 C116.4,49.7,115.4,48.7,114.1,48.7C114.2,48.7,114.1,48.7,114.1,48.7z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M98.6,72.5v5H87.4v-5C91,73.9,95,73.9,98.6,72.5z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M402.2,116.9c0,10.1,8.2,18.4,18.4,18.4s18.4-8.2,18.4-18.4c0-10.1-8.2-18.4-18.4-18.4l0,0 C410.5,98.6,402.3,106.8,402.2,116.9L402.2,116.9z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M408.9,116.9c0,6.5,5.2,11.7,11.7,11.7s11.7-5.2,11.7-11.7s-5.2-11.7-11.7-11.7S408.9,110.4,408.9,116.9z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M408.9,116.9c0,0.9,0.1,1.8,0.3,2.6c1.6-0.4,3.3,0.2,4.1,1.6c0.8,1.4,0.5,3.2-0.7,4.4c1.3,1.2,2.8,2.1,4.5,2.6 c0.4-1.9,2.3-3.2,4.2-2.8c1.4,0.3,2.5,1.4,2.8,2.8c1.7-0.5,3.2-1.4,4.5-2.6c-1.2-1.1-1.5-2.9-0.7-4.4c0.9-1.4,2.5-2,4.1-1.6 c0.2-0.9,0.4-1.7,0.3-2.6c0-0.9-0.1-1.7-0.3-2.5c-1.9,0.6-3.9-0.4-4.5-2.3c-0.4-1.3,0-2.8,1-3.7c-1.3-1.2-2.8-2-4.5-2.6 c-0.4,1.9-2.3,3.2-4.2,2.8c-1.4-0.3-2.5-1.4-2.8-2.8c-1.7,0.5-3.2,1.4-4.5,2.6c1.2,1.1,1.5,2.9,0.7,4.4c-0.9,1.4-2.6,2-4.2,1.6 C409,115.1,408.9,116,408.9,116.9z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M351.5,116.9c0,10.1,8.2,18.4,18.4,18.4s18.4-8.2,18.4-18.4c0-10.1-8.2-18.4-18.4-18.4l0,0 C359.8,98.6,351.6,106.8,351.5,116.9L351.5,116.9z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M358.2,116.9c0,6.5,5.2,11.7,11.7,11.7s11.7-5.2,11.7-11.7s-5.2-11.7-11.7-11.7S358.2,110.4,358.2,116.9z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M358.2,116.9c0,0.9,0.1,1.8,0.3,2.6c1.6-0.4,3.3,0.2,4.1,1.6c0.8,1.4,0.5,3.2-0.7,4.4c1.3,1.2,2.8,2.1,4.5,2.6 c0.4-1.9,2.3-3.2,4.3-2.7c1.4,0.3,2.5,1.4,2.7,2.7c1.7-0.5,3.2-1.4,4.5-2.6c-1.2-1.1-1.5-2.9-0.7-4.4c0.9-1.4,2.5-2.1,4.1-1.6 c0.2-0.9,0.4-1.7,0.3-2.6c0-0.9-0.1-1.7-0.3-2.5c-1.9,0.6-3.9-0.5-4.5-2.4c-0.4-1.3,0-2.8,1-3.7c-1.3-1.2-2.8-2-4.5-2.6 c-0.4,1.9-2.3,3.2-4.3,2.7c-1.4-0.3-2.5-1.4-2.7-2.7c-1.7,0.5-3.2,1.4-4.5,2.6c1.2,1.1,1.5,2.9,0.7,4.4c-0.9,1.4-2.6,2-4.2,1.6 C358.3,115.1,358.2,116,358.2,116.9z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M219,116.9c0,10.1,8.2,18.4,18.4,18.4s18.4-8.2,18.4-18.4c0-10.1-8.2-18.4-18.4-18.4l0,0 C227.2,98.6,219,106.8,219,116.9L219,116.9z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M225.6,116.9c0,6.5,5.2,11.7,11.7,11.7s11.7-5.2,11.7-11.7s-5.2-11.7-11.7-11.7S225.6,110.4,225.6,116.9z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M225.6,116.9c0,0.9,0.1,1.8,0.3,2.6c1.6-0.4,3.3,0.2,4.1,1.6s0.5,3.2-0.7,4.4c1.3,1.2,2.8,2.1,4.4,2.6 c0.4-1.9,2.3-3.2,4.3-2.7c1.4,0.3,2.5,1.4,2.7,2.7c1.7-0.5,3.2-1.4,4.5-2.6c-1.2-1.1-1.5-2.9-0.7-4.4c0.9-1.4,2.5-2.1,4.1-1.6 c0.2-0.9,0.4-1.7,0.3-2.6c0-0.9-0.1-1.7-0.3-2.5c-1.9,0.6-3.9-0.4-4.5-2.3c-0.4-1.3,0-2.8,1-3.7c-1.3-1.2-2.8-2-4.5-2.6 c-0.4,1.9-2.3,3.2-4.2,2.8c-1.4-0.3-2.5-1.4-2.8-2.8c-1.7,0.5-3.2,1.4-4.5,2.6c1.2,1.1,1.5,2.9,0.7,4.4c-0.9,1.4-2.6,2-4.2,1.6 C225.7,115.1,225.6,116,225.6,116.9z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M168.3,116.9c0,10.1,8.2,18.4,18.4,18.4s18.4-8.2,18.4-18.4c0-10.1-8.2-18.4-18.4-18.4l0,0 C176.5,98.6,168.3,106.8,168.3,116.9L168.3,116.9z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M175,116.9c-0.2,6.5,4.9,11.9,11.4,12.1s11.9-4.9,12.1-11.4c0-0.2,0-0.5,0-0.7c-0.2-6.5-5.6-11.6-12.1-11.4 C180.2,105.7,175.2,110.7,175,116.9z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M175,116.9c0,0.9,0.1,1.8,0.3,2.6c1.6-0.4,3.3,0.2,4.1,1.6s0.5,3.2-0.7,4.4c1.3,1.2,2.8,2.1,4.4,2.6 c0.4-1.9,2.3-3.2,4.3-2.7c1.4,0.3,2.5,1.4,2.7,2.7c1.7-0.5,3.2-1.4,4.4-2.6c-1.2-1.1-1.5-2.9-0.7-4.4c0.9-1.4,2.5-2.1,4.1-1.6 c0.2-0.9,0.3-1.7,0.3-2.6s-0.1-1.7-0.3-2.5c-1.9,0.6-3.9-0.5-4.5-2.4c-0.4-1.3,0-2.8,1-3.7c-1.3-1.2-2.8-2-4.4-2.6 c-0.4,1.9-2.3,3.2-4.3,2.7c-1.4-0.3-2.5-1.4-2.7-2.7c-1.7,0.5-3.2,1.4-4.5,2.6c1.2,1.1,1.5,2.9,0.7,4.4c-0.9,1.4-2.6,2-4.2,1.6 C175.1,115.1,175,116,175,116.9z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M31,116.9c0,10.1,8.2,18.4,18.4,18.4s18.4-8.2,18.4-18.4c0-10.1-8.2-18.4-18.4-18.4l0,0 C39.2,98.6,31,106.8,31,116.9L31,116.9z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M37.6,116.9c0,6.5,5.2,11.7,11.7,11.7S61,123.4,61,116.9l0,0c0-6.5-5.2-11.7-11.7-11.7S37.6,110.4,37.6,116.9z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M37.6,116.9c0,0.9,0.1,1.8,0.4,2.6c1.6-0.4,3.3,0.2,4.1,1.6s0.5,3.2-0.7,4.4c1.3,1.2,2.8,2.1,4.5,2.6 c0.4-1.9,2.3-3.2,4.3-2.7c1.4,0.3,2.5,1.4,2.7,2.7c1.7-0.5,3.2-1.4,4.5-2.6c-1.2-1.1-1.5-2.9-0.7-4.4c0.9-1.4,2.5-2.1,4.1-1.6 c0.2-0.9,0.3-1.7,0.3-2.6s-0.1-1.7-0.3-2.5c-1.9,0.6-3.9-0.5-4.5-2.4c-0.4-1.3,0-2.8,1-3.7c-1.3-1.2-2.8-2-4.5-2.6 c-0.4,1.9-2.3,3.2-4.3,2.7c-1.4-0.3-2.5-1.4-2.7-2.7c-1.7,0.5-3.2,1.4-4.5,2.6c1.2,1.1,1.5,2.9,0.7,4.4c-0.9,1.4-2.6,2-4.2,1.6 C37.7,115.1,37.6,116,37.6,116.9z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M144.4,112.7v8.5c0,2.2-1.7,3.9-3.9,3.9l0,0h-30c-2.2,0-3.9-1.7-3.9-3.9l0,0v-8.5c0-2.2,1.7-3.9,3.9-3.9l0,0h30 C142.7,108.8,144.4,110.5,144.4,112.7L144.4,112.7z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M115.4,128c-0.9,0-1.6-0.7-1.6-1.6l0,0v-18.9c0.1-0.9,0.9-1.6,1.8-1.5c0.8,0.1,1.4,0.7,1.5,1.5v18.9 C117.1,127.3,116.4,128,115.4,128L115.4,128z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M125.5,128c-0.9,0-1.6-0.7-1.6-1.6l0,0v-18.9c0-0.9,0.7-1.6,1.6-1.6s1.6,0.7,1.6,1.6v18.9 C127.1,127.3,126.4,128,125.5,128L125.5,128z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M135.5,128c-0.9,0-1.6-0.7-1.6-1.6l0,0v-18.9c0-0.9,0.7-1.6,1.6-1.6c0.9,0,1.6,0.7,1.6,1.6v18.9 C137.2,127.3,136.4,128,135.5,128L135.5,128z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M131,9.5c0,0.8-0.8,1.3-1.8,1.3s-1.8-0.6-1.8-1.3s0.8-1.2,1.8-1.2S131,8.8,131,9.5z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M167.4,4.9h271.8c6.4,0,11.6,4.9,11.6,11v63c0,6.1-5.2,11-11.6,11H167.4c-6.4,0-11.6-4.9-11.6-11v-63 C155.8,9.8,161,4.9,167.4,4.9z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruckTanker);
export default __webpack_public_path__ + "static/media/TruckTanker.20cec6b2637a1ecd040627889a13dbf2.svg";
export { ForwardRef as ReactComponent };